import React, { useState, useEffect } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getBookingsList } from "../../../../queries/queryFunctions/privetQueryFns/getQueryFns";
import { usePublicContext } from "../../../../providers/ReactPublicContextProvider";
import { toast } from "react-toastify";
import { patchExperienceStatusToArchiveQueryFn } from "../../../../queries/queryFunctions/privetQueryFns/patchQueryFns";
import BookingListComponent from "../../ui/bookingList";

const ApprovedBookingListComponent = ({ filter, searchData, activeTab, searchParams, activePage, handleSearch }) => {  
  const { setIsLoading } = usePublicContext();
  const [booking, setBooking] = useState();
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(10);
  const [passingSearchData, setPassingSearchData] = useState(null)


  const { data, isPending: isLoading, isError, error, refetch } = useQuery({
    queryKey: ["ApprovedBookingsList", { skip, limit , status: filter.status,  ...searchParams }],
    queryFn: getBookingsList,
  });

  useEffect(() => {
    if (data) {
      setBooking(data);
    }
  }, [data]);

  useEffect(() => {
    setIsLoading(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (activeTab === 'Booked' && searchData) {
      setBooking(searchData);
    }
  }, [searchData]);

  useEffect(() => {
    if (searchData) {
      setPassingSearchData(searchData);
    }
  }, [searchData]);

  return (
    <BookingListComponent
      data={booking}
      filter={filter}
      setSkip={setSkip}
      setLimit={setLimit}
      itemsPerPage={limit}
      allListActivePage={activePage}
      handleSearch={handleSearch}
      searchData={passingSearchData}
 
    />
  );
};

export default ApprovedBookingListComponent;
